export const mobileLogger = {
    hasTouchSupport() {
        return (
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            window.matchMedia('(pointer: coarse)').matches
        );
    },

    log(...args) {
        console.log(...args);

        let output = args.map((arg) => {
            if (typeof arg === "object") {
                return JSON.stringify(arg, null, 2);
            }
            return String(arg);
        }).join(" ");

        let viewer = document.getElementById("mobileLog");

        if (!viewer) {
            viewer = document.createElement("div");
            viewer.id = "mobileLog";
            viewer.style.width = "300px"; // Fixed width for vertical panel
            viewer.style.height = "100vh"; // Full height
            viewer.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
            viewer.style.color = "#00FF00";
            viewer.style.padding = "10px";
            viewer.style.overflowY = "scroll";
            viewer.style.position = "fixed";
            viewer.style.top = "0px"; // Start from top
            viewer.style.right = "0px"; // Align to right
            viewer.style.zIndex = "9999";
            viewer.style.fontFamily = "monospace";
            viewer.style.fontSize = "12px";
            viewer.style.boxSizing = "border-box";
            viewer.style.transition = "width 0.3s ease-in-out"; // Smooth width toggle

            // Header for minimizing
            const header = document.createElement("div");
            header.style.backgroundColor = "rgba(0, 0, 0, 0.9)";
            header.style.padding = "5px";
            header.style.cursor = "pointer";
            header.style.position = "sticky";
            header.style.top = "0";
            header.style.zIndex = "10000";
            header.innerText = "Debug Log (Click to minimize/maximize)";
            header.onclick = () => this.toggleMinimize(viewer);

            const clearBtn = document.createElement("button");
            clearBtn.innerText = "Clear";
            clearBtn.style.position = "absolute";
            clearBtn.style.top = "5px";
            clearBtn.style.right = "70px";
            clearBtn.style.padding = "5px";
            clearBtn.style.zIndex = "10001";
            clearBtn.onclick = (e) => {
                e.stopPropagation();
                const logContent = document.getElementById("mobileLogContent");
                if (logContent) logContent.innerHTML = "";
            };

            const closeBtn = document.createElement("button");
            closeBtn.innerText = "Close";
            closeBtn.style.position = "absolute";
            closeBtn.style.top = "5px";
            closeBtn.style.right = "5px";
            closeBtn.style.padding = "5px";
            closeBtn.style.zIndex = "10001";
            closeBtn.onclick = (e) => {
                e.stopPropagation();
                viewer.parentElement?.removeChild(viewer);
                const formContainer = document.querySelector('.formpage');
                if (formContainer) formContainer.style.paddingRight = "0";
            };

            const logContent = document.createElement("div");
            logContent.id = "mobileLogContent";
            logContent.style.marginTop = "30px";

            viewer.appendChild(header);
            viewer.appendChild(clearBtn);
            viewer.appendChild(closeBtn);
            viewer.appendChild(logContent);

            document.body.appendChild(viewer);

            // Add padding to form container to prevent overlap
            const formContainer = document.querySelector('.formpage');
            if (formContainer) formContainer.style.paddingRight = "300px";
        }

        const now = new Date();
        const timestamp = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}.${now.getMilliseconds().toString().padStart(3, '0')}`;

        const logContent = document.getElementById("mobileLogContent");
        if (logContent) {
            logContent.innerHTML += `<div><span style="color: #888;">[${timestamp}]</span> ${output}</div>`;
            logContent.scrollTop = logContent.scrollHeight;
        }
    },

    toggleMinimize(viewer) {
        const formContainer = document.querySelector('.formpage');
        if (viewer.style.width === "300px" || viewer.style.width === "") {
            viewer.style.width = "30px"; // Minimize to just header width
            if (formContainer) formContainer.style.paddingRight = "30px";
        } else {
            viewer.style.width = "300px";
            if (formContainer) formContainer.style.paddingRight = "300px";
        }
    },

    show() {
        const existing = document.getElementById("mobileLog");
        if (existing) {
            existing.parentElement?.removeChild(existing);
            const formContainer = document.querySelector('.formpage');
            if (formContainer) formContainer.style.paddingRight = "0";
        }

        this.log("Mobile logger initialized");
    }
};